import { render, staticRenderFns } from "./DataJalan.vue?vue&type=template&id=c16818b4&scoped=true"
import script from "./DataJalan.vue?vue&type=script&lang=js"
export * from "./DataJalan.vue?vue&type=script&lang=js"
import style0 from "./DataJalan.vue?vue&type=style&index=0&id=c16818b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16818b4",
  null
  
)

export default component.exports